import { useQueryClient, useMutation } from "@tanstack/react-query";
import { retrieveProject } from "./useRetrieveProject.query";
import { useRetrieveProjectProps } from "./useRetrieveProject.types";

export function useRetrieveProject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["retrieve_project"],
        mutationFn: async (projectId: useRetrieveProjectProps) => {
            const res = await retrieveProject(projectId);
            return res;
        },
        onSuccess: (_data, projectId)=> {
            queryClient.invalidateQueries({queryKey: ["projects_list"]});
            queryClient.invalidateQueries({queryKey: ["project", projectId]});
        }
    });
}
